import React from 'react';

import MemberFinishContent from '../MemberFinishContent';

function PostBetWaitingContent({ responsiveMode, viewProps }) {
  return (
    <>
      <MemberFinishContent
        {...viewProps}
        responsiveMode={responsiveMode}
      />
    </>
  );
}

export default PostBetWaitingContent;
